const activateImage = (image) => {
  if (image.dataset.deferredSrcset) {
    image.srcset = image.dataset.deferredSrcset;
    image.removeAttribute('data-deferred-srcset');
  }

  if (image.dataset.deferredSrc) {
    image.src = image.dataset.deferredSrc;
    image.removeAttribute('data-deferred-src');
  }

  image.removeAttribute('data-deferred-image');
};

class DeferredImageGroup extends HTMLElement {
  connectedCallback() {
    this.images = [...this.querySelectorAll('[data-deferred-image]')];
    if (!this.images.length) return;

    if (!('IntersectionObserver' in window)) {
      this.activate();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.activate();
      },
      { rootMargin: '650px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  activate() {
    this.images.forEach(activateImage);
    this.images = [];
    this.observer?.disconnect();
  }
}

if (!customElements.get('deferred-image-group')) {
  customElements.define('deferred-image-group', DeferredImageGroup);
}
